import { Stack, Typography } from '@mui/material';
import { isEmpty, map } from 'lodash';
import { CardLevel } from '../../../../components';
import { createScopedI18n } from '../../../../i18n/i18n';
import JobAttendanceCard from './job_attendance_card';

import type { JobHiringAttendance } from '../type';

const jobAttendanceListI18n = createScopedI18n('pages.attendances');

export type AttendancesListProps = {
  attendancesByJob: Record<string, JobHiringAttendance[]>;
};

const JobAttendancesList = ({ attendancesByJob }: AttendancesListProps) => (
  <Stack gap={1}>
    {isEmpty(attendancesByJob) ? (
      <CardLevel variant="outlined" level={1} sx={{ width: '100%' }}>
        <Stack justifyContent="center" alignItems="center" paddingX={2} padding={4}>
          <Typography variant="caption" textAlign="center" sx={{ opacity: 0.6 }}>
            {jobAttendanceListI18n('no_records')}
          </Typography>
        </Stack>
      </CardLevel>
    ) : (
      <>
        {map(attendancesByJob, (attendances, jobId) => (
          <JobAttendanceCard key={jobId} attendances={attendances} />
        ))}
      </>
    )}
  </Stack>
);
export default JobAttendancesList;
